"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryValues = exports.locationValues = exports.getLocationData = void 0;

var frontend_application_1 = require("@ryerson/frontend.application");
/*
    @desc - Location data support for Locations Menu
 *  @sources -
 *   canadian abbreviations
 *    https://en.wikipedia.org/wiki/Canadian_postal_abbreviations_for_provinces_and_territories
 *   mexico
 *    http://www.statoids.com/umx.html
 */
// prettier-ignore


var getLocationData = function getLocationData(language, country, locations) {
  var displayText = {
    en: "Locations",
    fr: "Emplacements",
    es: "Ubicaciones"
  }[language];
  var location = {
    name: "locations",
    display: displayText,
    active: true,
    items: getItems(language, country, locations) || []
  };
  return location;
};

exports.getLocationData = getLocationData; // prettier-ignore

var getItems = function getItems(language, country, locations) {
  switch (country) {
    default:
    case frontend_application_1.Country.us:
      if (locations.length > 12) {
        return [{
          header: "",
          items: locations.slice(0, 13).map(function (location) {
            return {
              active: true,
              value: location.urlLabel,
              display: withLanguage[location.id][language]
            };
          })
        }, {
          header: "",
          items: locations.slice(13, 26).map(function (location) {
            return {
              active: true,
              value: location.urlLabel,
              display: withLanguage[location.id][language]
            };
          })
        }, {
          header: "",
          items: locations.slice(26, 39).map(function (location) {
            return {
              active: true,
              value: location.urlLabel,
              display: withLanguage[location.id][language]
            };
          })
        }, {
          header: "",
          items: locations.slice(39, 50).map(function (location) {
            return {
              active: true,
              value: location.urlLabel,
              display: withLanguage[location.id][language]
            };
          })
        }];
      } else {
        return [{
          header: "",
          items: locations.map(function (location) {
            return {
              active: true,
              value: location.urlLabel,
              display: withLanguage[location.id][language]
            };
          })
        }];
      }

    case frontend_application_1.Country.mx:
      return [{
        header: "",
        items: locations.map(function (location) {
          return {
            active: true,
            value: location.urlLabel,
            display: withLanguage[location.id][language]
          };
        })
      }];

    case frontend_application_1.Country.ca:
      return [{
        header: "",
        items: locations.map(function (location) {
          return {
            active: true,
            value: location.urlLabel,
            display: withLanguage[location.id][language]
          };
        })
      }];
  }
}; // Translations


var withLanguage = {
  AL: {
    en: "Alabama",
    fr: "Alabama",
    es: "Alabama"
  },
  AK: {
    en: "Alaska",
    fr: "Alaska",
    es: "Alaska"
  },
  AZ: {
    en: "Arizona",
    fr: "Arizona",
    es: "Arizona"
  },
  AR: {
    en: "Arkansas",
    fr: "Arkansas",
    es: "Arkansas"
  },
  CA: {
    en: "California",
    fr: "Californie",
    es: "California"
  },
  CO: {
    en: "Colorado",
    fr: "Colorado",
    es: "Colorado"
  },
  CT: {
    en: "Connecticut",
    fr: "Connecticut",
    es: "Connecticut"
  },
  DE: {
    en: "Delaware",
    fr: "Delaware",
    es: "Delaware"
  },
  FL: {
    en: "Florida",
    fr: "Floride",
    es: "Florida"
  },
  GA: {
    en: "Georgia",
    fr: "Géorgie",
    es: "Georgia"
  },
  HI: {
    en: "Hawaii",
    fr: "Hawaï",
    es: "Hawái"
  },
  ID: {
    en: "Idaho",
    fr: "Idaho",
    es: "Idaho"
  },
  IL: {
    en: "Illinois",
    fr: "Illinois",
    es: "Illinois"
  },
  IN: {
    en: "Indiana",
    fr: "Indiana",
    es: "Indiana"
  },
  IA: {
    en: "Iowa",
    fr: "Iowa",
    es: "Iowa"
  },
  KS: {
    en: "Kansas",
    fr: "Kansas",
    es: "Kansas"
  },
  KY: {
    en: "Kentucky",
    fr: "Kentucky",
    es: "Kentucky"
  },
  LA: {
    en: "Louisiana",
    fr: "Louisiane",
    es: "Luisiana"
  },
  ME: {
    en: "Maine",
    fr: "Maine",
    es: "Maine"
  },
  MD: {
    en: "Maryland",
    fr: "Maryland",
    es: "Maryland"
  },
  MA: {
    en: "Massachusetts",
    fr: "Massachusetts",
    es: "Massachusetts"
  },
  MI: {
    en: "Michigan",
    fr: "Michigan",
    es: "Michigan"
  },
  MN: {
    en: "Minnesota",
    fr: "Minnesota",
    es: "Minesota"
  },
  MS: {
    en: "Mississippi",
    fr: "Mississippi",
    es: "Misisipi"
  },
  MO: {
    en: "Missouri",
    fr: "Missouri",
    es: "Misuri"
  },
  MT: {
    en: "Montana",
    fr: "Montana",
    es: "Montana"
  },
  NE: {
    en: "Nebraska",
    fr: "Nebraska",
    es: "Nebraska"
  },
  NV: {
    en: "Nevada",
    fr: "Nevada",
    es: "Nevada"
  },
  NH: {
    en: "New Hampshire",
    fr: "New Hampshire",
    es: "Nuevo Hampshire"
  },
  NJ: {
    en: "New Jersey",
    fr: "New Jersey",
    es: "Nueva Jersey"
  },
  NM: {
    en: "New Mexico",
    fr: "Nouveau-Mexique",
    es: "Nuevo México"
  },
  NY: {
    en: "New York",
    fr: "l'état de New York",
    es: "Nueva York"
  },
  NC: {
    en: "North Carolina",
    fr: "Caroline du Nord",
    es: "Carolina del Norte"
  },
  ND: {
    en: "North Dakota",
    fr: "Dakota du Nord",
    es: "Dakota del Norte"
  },
  OH: {
    en: "Ohio",
    fr: "Ohio",
    es: "Ohio"
  },
  OK: {
    en: "Oklahoma",
    fr: "Oklahoma",
    es: "Oklahoma"
  },
  OR: {
    en: "Oregon",
    fr: "Oregon",
    es: "Oregón"
  },
  PA: {
    en: "Pennsylvania",
    fr: "Pennsylvanie",
    es: "Pensilvania"
  },
  RI: {
    en: "Rhode Island",
    fr: "Rhode Island",
    es: "Rhode Island"
  },
  SC: {
    en: "South Carolina",
    fr: "Caroline du Sud",
    es: "Carolina del Sur"
  },
  SD: {
    en: "South Dakota",
    fr: "Dakota du Sud",
    es: "Dakota del Sur"
  },
  TN: {
    en: "Tennessee",
    fr: "Tennessee",
    es: "Tennessee"
  },
  TX: {
    en: "Texas",
    fr: "Texas",
    es: "Texas"
  },
  UT: {
    en: "Utah",
    fr: "Utah",
    es: "Utah"
  },
  VT: {
    en: "Vermont",
    fr: "Vermont",
    es: "Vermont"
  },
  VA: {
    en: "Virginia",
    fr: "Virginie",
    es: "Virginia"
  },
  WA: {
    en: "Washington",
    fr: "l'état de Washington",
    es: "Washington"
  },
  WV: {
    en: "West Virginia",
    fr: "Virginie-Occidentale",
    es: "Virginia Occidental"
  },
  WI: {
    en: "Wisconsin",
    fr: "Wisconsin",
    es: "Wisconsin"
  },
  WY: {
    en: "Wyoming",
    fr: "Wyoming",
    es: "Wyoming"
  },
  // Provinces in Canada
  AB: {
    en: "Alberta",
    fr: "L'Alberta",
    es: "Alberta"
  },
  BC: {
    en: "British Columbia",
    fr: "La Colombie-Britannique",
    es: "Columbia Británica"
  },
  MB: {
    en: "Manitoba",
    fr: "Le Manitoba",
    es: "Manitoba"
  },
  NB: {
    en: "New Brunswick",
    fr: "Le Nouveau-Brunswick",
    es: "	Nuevo Brunswick"
  },
  ON: {
    en: "Ontario",
    fr: "L'Ontario",
    es: "Ontario"
  },
  QC: {
    en: "Quebec",
    fr: "Le Québec",
    es: "Quebec"
  },
  // Capitals in mexico (no postal abbreviations found)
  Hermosillo: {
    en: "Hermosillo",
    fr: "Hermosillo",
    es: "Hermosillo"
  },
  Monterrey: {
    en: "Monterrey",
    fr: "Monterrey",
    es: "Monterrey"
  },
  Queretaro: {
    en: "Queretaro",
    fr: "Queretaro",
    es: "Querétaro"
  },
  Tijuana: {
    en: "Tijuana",
    fr: "Tijuana",
    es: "Tijuana"
  }
};
var locationValues;

(function (locationValues) {
  locationValues["AL"] = "Alabama";
  locationValues["AK"] = "Alaska";
  locationValues["AZ"] = "Arizona";
  locationValues["AR"] = "Arkansas";
  locationValues["CA"] = "California";
  locationValues["CO"] = "Colorado";
  locationValues["CT"] = "Connecticut";
  locationValues["DE"] = "Delaware";
  locationValues["FL"] = "Florida";
  locationValues["GA"] = "Georgia";
  locationValues["HI"] = "Hawaii";
  locationValues["ID"] = "Idaho";
  locationValues["IL"] = "Illinois";
  locationValues["IN"] = "Indiana";
  locationValues["IA"] = "Iowa";
  locationValues["KS"] = "Kansas";
  locationValues["KY"] = "Kentucky";
  locationValues["LA"] = "Louisiana";
  locationValues["ME"] = "Maine";
  locationValues["MD"] = "Maryland";
  locationValues["MA"] = "Massachusetts";
  locationValues["MI"] = "Michigan";
  locationValues["MN"] = "Minnesota";
  locationValues["MS"] = "Mississippi";
  locationValues["MO"] = "Missouri";
  locationValues["MT"] = "Montana";
  locationValues["NE"] = "Nebraska";
  locationValues["NV"] = "Nevada";
  locationValues["NH"] = "New Hampshire";
  locationValues["NJ"] = "New Jersey";
  locationValues["NM"] = "New Mexico";
  locationValues["NY"] = "New York";
  locationValues["NC"] = "North Carolina";
  locationValues["ND"] = "North Dakota";
  locationValues["OH"] = "Ohio";
  locationValues["OK"] = "Oklahoma";
  locationValues["OR"] = "Oregon";
  locationValues["PA"] = "Pennsylvania";
  locationValues["RI"] = "Rhode Island";
  locationValues["SC"] = "South Carolina";
  locationValues["SD"] = "South Dakota";
  locationValues["TN"] = "Tennessee";
  locationValues["TX"] = "Texas";
  locationValues["UT"] = "Utah";
  locationValues["VT"] = "Vermont";
  locationValues["VA"] = "Virginia";
  locationValues["WA"] = "Washington";
  locationValues["WV"] = "West Virginia";
  locationValues["WI"] = "Wisconsin";
  locationValues["WY"] = "Wyoming";
  locationValues["AB"] = "Alberta";
  locationValues["BC"] = "British Columbia";
  locationValues["MB"] = "Manitoba";
  locationValues["NB"] = "New Brunswick";
  locationValues["ON"] = "Ontario";
  locationValues["QC"] = "Quebec";
  locationValues["Hermosillo"] = "Hermosillo";
  locationValues["Monterrey"] = "Monterrey";
  locationValues["Queretaro"] = "Queretaro";
  locationValues["Tijuana"] = "Tijuana";
  locationValues["AllLocations"] = "AllLocations";
})(locationValues || (exports.locationValues = locationValues = {}));

var countryValues;

(function (countryValues) {
  countryValues["us"] = "United States";
  countryValues["ca"] = "Canada";
  countryValues["mx"] = "Mexico";
  countryValues["cn"] = "China";
})(countryValues || (exports.countryValues = countryValues = {}));